import React from 'react';
import { useData } from '../../context/DataContext';

export const MobileDrawer = ({ isOpen, onClose }) => {
  const { activeTab, setActiveTab } = useData();

  if (!isOpen) return null;

  const menuItems = [
    { id: 'participation', label: 'Student Participation', icon: '✅' },
    { id: 'overview', label: 'Performance Overview', icon: '📊' },
    { id: 'curriculum', label: 'Curriculum Analysis', icon: '📖' },
    { id: 'reports', label: 'Report Card', icon: '📋' },
    { id: 'papers', label: 'Question Papers', icon: '📝' },
  ];

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    onClose();
  };

  return (
    <>
      {/* Backdrop overlay */}
      <div
        className="fixed inset-0 bg-black/50 z-40 lg:hidden"
        onClick={onClose}
      ></div>

      {/* Drawer panel */}
      <aside
        className="fixed top-20 left-0 bottom-0 w-72 overflow-y-auto z-50 shadow-xl lg:hidden select-none"
        style={{ backgroundColor: '#347363' }}
      >
        <nav className="p-5 space-y-2">
          {menuItems.map((item) => {
            const isActive = activeTab === item.id;
            return (
              <button
                key={item.id}
                onClick={() => handleTabClick(item.id)}
                className={`nav-item flex items-center space-x-4 px-5 py-4 rounded-xl text-white w-full text-left cursor-pointer ${
                  isActive ? 'active' : ''
                }`}
              >
                <span className="text-2xl">{item.icon}</span>
                <span className="font-medium text-base">{item.label}</span>
              </button>
            );
          })}
        </nav>
      </aside>
    </>
  );
};
export default MobileDrawer;
